// In your main React component (or a separate component like CookieConsent.js)

import React, { useState } from 'react';
import './CookieConsent.css';  // Add your custom CSS styling

export default function CookieConsent() {
  const [isConsentGiven, setConsentGiven] = useState(false);

  const handleConsent = () => {
    setConsentGiven(true);
    localStorage.setItem('cookieConsent', 'true');  // Store user consent in local storage
  };

  // Check if user already gave consent (optional: could be based on localStorage or cookies)
  if (localStorage.getItem('cookieConsent') === 'true') {
    return null;  // Don't show the banner if consent is already given
  }

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-message">
        We use cookies to improve your experience. By continuing to browse the site, you agree to our
        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer"> Privacy Policy</a> &amp;
        <a href="/cookie-policy" target="_blank" rel="noopener noreferrer"> Cookie Policy</a>.
      </div>
      <button className="cookie-consent-btn" onClick={handleConsent}>
        Got it
      </button>
    </div>
  );
}
